module.exports = __webpack_public_path__ + "img/一键生成报告低.b33304b2.png";